(() => {
  document.querySelectorAll('[data-collection-accordion]').forEach((accordion) => {
    const button = accordion.querySelector('[data-collection-accordion-toggle]');
    const panel = accordion.querySelector('[data-collection-accordion-panel]');
    if (!button || !panel) return;

    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      accordion.classList.toggle('is-open', !isOpen);
    });
  });
})();
